import { Grid, IconButton, Theme, useTheme } from "@mui/material";
import { nunitoBase } from "../../technical/style/theme";
import React, { ReactNode } from "react";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";

export const processDialogHeaderStyles = (theme: Theme) => ({
  formHeader: {
    padding: theme.spacing(2),
    backgroundColor: theme.palette.background.default
  },

  dialogHeaderField: {
    display: 'flex',
  },

  dialogHeaderData: {
    alignSelf: 'center',
    color: theme.palette.text.secondary,
    fontSize: '14px',
    fontWeight: 'bold',
    ...nunitoBase
  }
});

export function ProcessDialogHeader(props: {
  title: string,
  handleClose: () => void,
  children?: ReactNode,
}) {
  const theme = useTheme();

  const titleStyle = {
    xs: 12,
    sm: props.children ? 6 : 12,
    md: props.children ? 4 : 12,
  }

  return (
    <Grid container={ true } sx={ processDialogHeaderStyles(theme).formHeader }>
      <Grid item={ true } xs={ 11 }>
        <Grid container={ true }>
          <Grid item={ true } { ...titleStyle }>
            <Typography variant={ 'h5' }>{ props.title }</Typography>
          </Grid>
          { props.children }
        </Grid>
      </Grid>
      <Grid item={ true } xs={ 1 } style={ {display: 'flex'} }>
        <IconButton size={ "small" } onClick={ props.handleClose } style={ {marginLeft: 'auto'} }>
          <CloseIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}
